module.exports = __webpack_public_path__ + "static/media/resultsGraphicFailed2_mobile.66fd1636.jpg";